import React from 'react'
import {ScrollToBottomProps} from './types'
import ScrollToBottomView from './ScrollToBottomView'

const ScrollToBottom = (props: ScrollToBottomProps): React.ReactElement => <ScrollToBottomView {...props} />


export default ScrollToBottom
